import { ca } from '@cian/analytics';

export const trackAuctionBlockOpen = (isBetHolded) => {
  const label = isBetHolded ? 'passive' : 'bid';

  ca('event', {
    name: 'oldevent',
    category: 'Auction_block',
    action: 'Open',
    label,
  });
};

export const trackAuctionBlockChangeBid = () => {
  ca('event', {
    name: 'oldevent',
    category: 'Auction_block',
    action: 'Change_bid',
  });
};

export const trackAuctionMoreInfoClick = () => {
  ca('event', {
    name: 'oldevent',
    category: 'Auction_block',
    action: 'Click_more_info',
  });
};
